import store from "../store/index";
import webconfig from "../webconfig.config";
import { Toast } from "vant";

// 配置API接口地址
var root = webconfig.WebApi;
// 引用axios
var axios = require("axios");
var qs = require("qs");
const https = require("https");

// axios.defaults.headers = {
// 	"Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
// };
// axios.defaults.paramsSerializer = (params) => {
// 	return qs.stringify(params, {arrayFormat: 'brackets'});
// }

// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === "string") {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}
/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
  另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/

function apiAxios(method, url, params, success, failure) {
  var asscessToken = localStorage.getItem("token");
  
  // console.log(asscessToken);
  if (params) {
    // if (method === "POST" || method === "PUT") {
    //   params = qs.stringify(params);
    // } else 
    if (method === "GET") {
      params = filterNull(params);
    }
  }
  Toast.loading({
    mask: false,
    forbidClick: true,
    message: "加载中...",
    duration: 0
  });

  // console.log(root+"/"+url);
  //console.log(method+"~"+params)

//   // 实例对象
//   let instance = axios.create({
//     timeout: 3000,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })

//   // 请求拦截器
// instance.interceptors.request.use(
//   config => {
//     config.data = qs.stringify(config.data) // 转为formdata数据格式
//     return config
//   },
//   error => Promise.error(error)
// )

  // 在 axios 请求时，选择性忽略 SSL
  const agent = new https.Agent({
    rejectUnauthorized: false
  });

  axios({
    httpsAgent: agent,
    timeout: 20000,
    method: method,
    url: url,
    data: method === "POST" || method === "PUT"|| method === "DELETE" ? params : null,
    params: method === "GET" ? params : null,
    headers: {
      Authorization: "Bearer " + asscessToken,
      "Content-Type": "application/json",
      // "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
      // "Access-Control-Allow-Origin":"*",
      // "Access-Control-Allow-Methods":"POST, GET, OPTIONS, PUT, PATCH, DELETE",
      // "Access-Control-Allow-Headers":"Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Authorization , Access-Control-Request-Headers"
    },
    baseURL: root,
    withCredentials: false
  })
    .then(function(res) {
      //console.log(res);
      if (res.status === 200) {
        if (success) {
          // console.log(res.data);
          success(res.data);
        }
      } else {
        if (failure) {
          failure(res.data);
        } else {
          window.alert("error: " + JSON.stringify(res.data));
        }
      }
      Toast.clear();
    })
    .catch(function(err) {
      // console.log(err)
      let res = err.response;
      // if (res.status==401){
      //   window.location.href="/Login";
      // }
      if (err) {
        failure(res);
        //console.log(res)
        //window.alert('api error, HTTP CODE: ' + res.status)
      }
      Toast.clear();
    });
}

function apiNSAxios(method, url, params, success, failure) {
  var asscessToken = localStorage.getItem("token");
  
  // console.log(asscessToken);
  if (params) {
    // if (method === "POST" || method === "PUT") {
    //   params = qs.stringify(params);
    // } else 
    if (method === "GET") {
      params = filterNull(params);
    }
  }

//   // 实例对象
//   let instance = axios.create({
//     timeout: 3000,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })

//   // 请求拦截器
// instance.interceptors.request.use(
//   config => {
//     config.data = qs.stringify(config.data) // 转为formdata数据格式
//     return config
//   },
//   error => Promise.error(error)
// )

  // 在 axios 请求时，选择性忽略 SSL
  const agent = new https.Agent({
    rejectUnauthorized: false
  });

  axios({
    httpsAgent: agent,
    timeout: 5000,
    method: method,
    url: url,
    data: method === "POST" || method === "PUT"|| method === "DELETE" ? params : null,
    params: method === "GET" ? params : null,
    headers: {
      Authorization: "Bearer " + asscessToken,
      "Content-Type": "application/json",
      // "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
      // "Access-Control-Allow-Origin":"*",
      // "Access-Control-Allow-Methods":"POST, GET, OPTIONS, PUT, PATCH, DELETE",
      // "Access-Control-Allow-Headers":"Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Authorization , Access-Control-Request-Headers"
    },
    baseURL: root,
    withCredentials: false
  })
    .then(function(res) {
      console.log(res);
      if (res.status === 200) {
        if (success) {
          // console.log(res.data);
          success(res.data);
        }
      } else {
        if (failure) {
          failure(res.data);
        } else {
          window.alert("error: " + JSON.stringify(res.data));
        }
      }
    })
    .catch(function(err) {
      // console.log(err)
      let res = err.response;
      if (res.status==401){
        // window.location.href="/Login";
        Toast.fail("授权失败，请重新登录再尝试！")
      }
      if (err) {
        failure(res);
        //console.log(res)
        //window.alert('api error, HTTP CODE: ' + res.status)
      }
    });
}

// 返回在vue模板中的调用接口
export default {
  get: function(url, params, success, failure) {
    return apiAxios("GET", url, params, success, failure);
  },
  getNs: function(url, params, success, failure) {
    return apiNSAxios("GET", url, params, success, failure);
  },
  post: function(url, params, success, failure) {
    return apiAxios("POST", url, params, success, failure);
  },
  postNs: function(url, params, success, failure) {
    return apiNSAxios("POST", url, params, success, failure);
  },
  put: function(url, params, success, failure) {
    return apiAxios("PUT", url, params, success, failure);
  },
  putNs: function(url, params, success, failure) {
    return apiNSAxios("PUT", url, params, success, failure);
  },
  delete: function(url, params, success, failure) {
    return apiAxios("DELETE", url, params, success, failure);
  },
  deleteNs: function(url, params, success, failure) {
    return apiNSAxios("DELETE", url, params, success, failure);
  }
};



// WEBPACK FOOTER //
// ./src/api/index.js